module.exports = __webpack_public_path__ + "static/media/3 01 Tulleord Intro.3b269f8f.mp3";